import { render, staticRenderFns } from "./BooleanProperty.vue?vue&type=template&id=8dc75bde&"
import script from "./BooleanProperty.vue?vue&type=script&lang=js&"
export * from "./BooleanProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports